import { SearchBox } from "./InputBox"
import { Link } from "react-router-dom"

const Header = () => {
  return (
    <div className="top_panel">
      <div className="logo" />
      <div className="menu">
        <Link to='/leaderboard-batter'><div className="menu_block">打者排行</div></Link>
        <Link to='/leaderboard-pitcher'><div className="menu_block">投手排行</div></Link>
        <Link to='/personal-batter'><div className="menu_block">打者個人</div></Link>
        <Link to='/personal-pitcher'><div className="menu_block">投手個人</div></Link>
      </div>
      {/*<SearchBox placeholder='搜尋選手' />*/}
    </div>
  )
}

export default Header